/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wu_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It checks every word in a large English dictionary and keeps the ones that can be spelled using your letters (each letter used no more times than you have it), then sorts them by length.`)
};

const es_wu_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprueba cada palabra de un extenso diccionario en inglés y conserva las que se pueden formar con tus letras (cada letra se usa como máximo el número de veces que la tienes), y luego las ordena por longitud.`)
};

const de_wu_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es prüft jedes Wort in einem umfangreichen englischen Wörterbuch und behält die, die sich mit deinen Buchstaben bilden lassen (jeder Buchstabe wird höchstens so oft verwendet, wie du ihn hast), und sortiert sie anschließend nach Länge.`)
};

const nl_wu_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het controleert elk woord in een groot Engels woordenboek en behoudt de woorden die met jouw letters gespeld kunnen worden (elke letter nooit vaker gebruikt dan je hem hebt), en sorteert ze vervolgens op lengte.`)
};

const fr_wu_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il vérifie chaque mot d'un vaste dictionnaire anglais et conserve ceux qui peuvent s'écrire avec vos lettres (chaque lettre étant utilisée au maximum le nombre de fois où vous la possédez), puis les trie par longueur.`)
};

const it_wu_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controlla ogni parola in un ampio dizionario inglese e conserva quelle che possono essere scritte con le tue lettere (ogni lettera usata non più volte di quante ne hai), quindi le ordina per lunghezza.`)
};

const pt_br2_wu_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ele verifica cada palavra em um grande dicionário de inglês e mantém as que podem ser formadas com suas letras (cada letra usada no máximo o número de vezes que você tem dela), depois as organiza por tamanho.`)
};

const pt_wu_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifica cada palavra num vasto dicionário inglês e mantém as que podem ser escritas com as suas letras (cada letra usada no máximo tantas vezes quantas a tem), ordenando-as depois por comprimento.`)
};

const ja_wu_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大規模な英語辞書に含まれるすべての単語をチェックし、手持ちの文字（各文字は実際に持っている回数までしか使いません）で綴れる単語だけを残し、長さ順に並べ替えます。`)
};

const zh_wu_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它会检查一部大型英语词典中的每一个单词，只保留那些能用你的字母拼出的单词（每个字母的使用次数不超过你实际拥有的数量），然后按长度排序。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wu_hub_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wu_hub_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wu_hub_faq1_a", locale)
	if (locale === "en") return en_wu_hub_faq1_a(inputs)
	if (locale === "es") return es_wu_hub_faq1_a(inputs)
	if (locale === "de") return de_wu_hub_faq1_a(inputs)
	if (locale === "nl") return nl_wu_hub_faq1_a(inputs)
	if (locale === "fr") return fr_wu_hub_faq1_a(inputs)
	if (locale === "it") return it_wu_hub_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_wu_hub_faq1_a(inputs)
	if (locale === "pt") return pt_wu_hub_faq1_a(inputs)
	if (locale === "ja") return ja_wu_hub_faq1_a(inputs)
	return zh_wu_hub_faq1_a(inputs)
};